import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import DOMPurify from 'dompurify';
import parseHtml from 'html-react-parser';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

const DataProcessingInfo: React.FC = () => {
  const { t } = useTranslationWithPrefix('consents');
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <p className="small">
        {t('dataProcessingInfoTitle')}
        <Button className="btn btn-link " onClick={toggleExpansion}>
          <span className="small pl-2">[{isExpanded ? t('collapse') : t('expand')}]</span>
        </Button>
      </p>
      {isExpanded && (
        <div className="small">
          {parseHtml(DOMPurify.sanitize(t('dataProcessingInfoHtml'), DomPurifyConfig))}
        </div>
      )}
    </div>
  );
};

export default DataProcessingInfo;
